import type { ICellRendererParams } from 'ag-grid-enterprise';
import { capitalize } from 'lodash';

import { VMPGenericChip } from '@/components/VMPGenericChip';

export const renderCvssScore = ({ data }: ICellRendererParams) => {
  return (
    <VMPGenericChip
      value={String(data?.cvss_level).toUpperCase()}
      text={`${data?.cvss} ${capitalize(data?.cvss_level)}`}
    />
  );
};

export const renderPonduranceScore = ({ data }: ICellRendererParams) => {
  return (
    <VMPGenericChip
      type="outlined"
      value={data?.severity}
      text={`${data?.vmp_exposure_index} ${capitalize(data?.severity || 'N/A')}`}
    />
  );
};
